import React from 'react';
import { Link } from 'react-router-dom';
import './Model.css';
import { cloudImg } from '../../general';

export default ({ model, type, category, viewSize }) => {
  const {
    firstName,
    lastName,
    slug,
    frontImgThumb,
  } = model;
  return Object.keys(frontImgThumb).length !== 0 && (
    <Link className="modelpage_model" to={`/${type}/${category}/${type === 'artists' ? 'image' : 'portfolio'}/${slug}`}>
      <img className="modelpage_model_img" src={cloudImg(frontImgThumb[`crop_${viewSize > 2 ? 3 : viewSize}`])} alt={firstName} />
      <p className="modelpage_model_p">
        {`${firstName} ${lastName}`}
      </p>
    </Link>
  );
};
